module.exports = __webpack_public_path__ + "img/juli-06930.946f9ba8.jpeg";